import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles((theme) => ({
  mainDiv: {
    padding: "15px 32px",
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  uiTab: {
    minHeight: "calc(100vh - 270px)",
    height: "100% !important",
  },
  titleStatusBadge: {
    height: "24px !important",
    width: "fit-content !important",
    fontFamily: "Manrope",
    marginRight: "8px",
    fontWeight: 600,
    fontSize: "13px",
    lineHeight: "16px",
  },
  checkboxGroup: {
    gap: "16px",
    justifyContent: "flex-start",
  },
  checkboxContainer: {
    display: "flex",
    gap: "50px",
  },
  chipContainer: {
    display: "flex",
    gap: "10px",
    marginTop: "10px",
  },
  buttonFeedbackCard: {
    marginTop: "16px",
  },
  gridContainer: {
    marginTop: "16px",
  },
  gridItem: {
    padding: "16px",
    borderRadius: "8px",
    backgroundColor: "#fff",
    boxShadow: "2px 4px 6px rgba(0, 0, 0, 0.1)",
    transition: "all 0.3s ease-in-out",
    "&:hover": {
      boxShadow: "0px 8px 12px rgba(0, 0, 0, 0.2)",
      transform: "scale(1.02)",
    },
  },
  formLabel: {
    color: "#308CDB",
    lineHeight: "1.5rem",
    weight: "bold",
    marginBottom: "0.625rem !important",
  },
  buttonGroup: {
    display: "flex",
    gap: "12px",
    flexWrap: "wrap",
    alignItems: "center",
    marginBottom: "24px",
  },
  buttonLabel: {
    marginBottom: "8px",
  },
}));

export default styles;
